/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

var emptyArray = [];
var emptyObject = {};
var noopFn = function noopFn() {};
var returnsTrueFn = function returnsTrueFn() {
  return true;
};

export { emptyArray, emptyObject, noopFn, returnsTrueFn };
